import { languages } from '@/store/language'

export const vcalendarOptions = {
  componentPrefix: 'vc' // Use <vc-calendar /> instead of <v-calendar />
}

const FALLBACK_LOCALE = 'ro'

// Cheia de limbă a aplicației (`state.lang`: 'ro', 'se', ...) → locale-ul
// calendarului, declarat în language.js la fiecare limbă (`locale`).
export function Calendar_Locale (lang) {
  return (languages[lang] && languages[lang].locale) || FALLBACK_LOCALE
}

// v-calendar 2.4.2 NU are opțiune globală de limbă: citește `locale` doar din
// prop-ul fiecărei componente, altfel ia limba browserului (pe un browser în
// engleză calendarul apărea în engleză). Setăm aici default-ul prop-ului pe
// componentele înregistrate, ca funcție care citește limba aplicației din store.
// `vc-date-picker` își transmite locale-ul calendarului intern, deci acoperă și
// popover-ul. Locale-ul dă și prima zi a săptămânii (ro / sv: luni).
// Default-ul e evaluat la montare: după schimbarea limbii în Setări, calendarele
// montate ulterior apar în noua limbă (cele deja afișate rămân până la remontare).
// ATENȚIE: depinde de structura internă v-calendar (props din options) — la un
// upgrade de v-calendar, tests/unit/vcalendar_options.spec.js prinde regresia.
export function Set_Vcalendar_Default_Locale (Vue, store) {
  const prefix = vcalendarOptions.componentPrefix
  // v-calendar le înregistrează ca `${prefix}${Nume}` (vcCalendar, vcDatePicker).
  ;['Calendar', 'DatePicker'].forEach((name) => {
    Vue.component(`${prefix}${name}`).options.props.locale.default = () => Calendar_Locale(store.state.lang)
  })
}
